import React, { useEffect, useState } from 'react';
import { PawPrint } from 'lucide-react';
interface LoadingScreenProps {
  dogName: string;
  onComplete: () => void;
}
export function LoadingScreen({
  dogName,
  onComplete
}: LoadingScreenProps) {
  const [progress, setProgress] = useState(0);
  const [stage, setStage] = useState(0);
  const stages = ['🔍 Evaluando síntomas reportados...', '🧬 Calculando nivel de envejecimiento...', '🍗 Identificando deficiencias nutricionales...', `📋 Construyendo plan personalizado para ${dogName}...`, '✅ ¡Perfil completado!'];
  useEffect(() => {
    // Progress bar animation (7 seconds total)
    const interval = setInterval(() => {
      setProgress(prev => {
        if (prev >= 100) {
          clearInterval(interval);
          return 100;
        }
        return prev + 1; // Increment by 1% every 70ms approx
      });
    }, 70);
    return () => clearInterval(interval);
  }, []);
  useEffect(() => {
    // Stage text rotation
    if (progress < 25) setStage(0);else if (progress < 50) setStage(1);else if (progress < 75) setStage(2);else if (progress < 95) setStage(3);else setStage(4);
    if (progress === 100) {
      setTimeout(onComplete, 500);
    }
  }, [progress, onComplete]);
  return <div className="min-h-screen flex flex-col items-center justify-center px-6 max-w-md mx-auto bg-background text-center" data-id="element-110">
      {/* Animated Icon */}
      <div className="mb-8 relative" data-id="element-111">
        <div className="absolute inset-0 bg-primary/20 rounded-full animate-ping opacity-75" data-id="element-112"></div>
        <div className="relative bg-white p-6 rounded-full shadow-lg border-4 border-primary/10" data-id="element-113">
          <PawPrint className="w-12 h-12 text-primary animate-pulse" data-id="element-114" />
        </div>
      </div>

      {/* Headline */}
      <h2 className="text-2xl font-bold text-text-main mb-8" data-id="element-115">
        Analizando el perfil de {dogName}...
      </h2>

      {/* Progress Bar */}
      <div className="w-full h-4 bg-gray-200 rounded-full mb-4 overflow-hidden" data-id="element-116">
        <div className="h-full bg-primary rounded-full transition-all duration-100 ease-linear relative overflow-hidden" style={{
        width: `${progress}%`
      }} data-id="element-117">
          <div className="absolute inset-0 bg-white/20 animate-[shimmer_2s_infinite]" data-id="element-118"></div>
        </div>
      </div>

      {/* Status Text */}
      <div className="h-16 flex items-center justify-center w-full" data-id="element-119">
        <p className="text-lg font-medium text-primary animate-in fade-in slide-in-from-bottom-2 duration-300 key={stage}" data-id="element-120">
          {stages[stage]}
        </p>
      </div>

      {/* Bottom Insight */}
      <div className={`mt-12 transition-opacity duration-1000 ${progress > 60 ? 'opacity-100' : 'opacity-0'}`} data-id="element-121">
        <p className="text-sm text-text-main/60 italic" data-id="element-122">
          "Basado en tus respuestas, hemos identificado factores clave en la
          vida de {dogName}..."
        </p>
      </div>
    </div>;
}